import React from "react"
import { VStack } from "@chakra-ui/react"

export default function Message({ children }) {
  return (
    <VStack
      justifyContent="center"
      alignItems="flex-start"
      p="3em"
      height="100%"
    >
      {children}
    </VStack>
  )
}
